import { render } from "./WebProfileHeader.vue?vue&type=template&id=6df7cb60&scoped=true"
import script from "./WebProfileHeader.vue?vue&type=script&lang=js"
export * from "./WebProfileHeader.vue?vue&type=script&lang=js"

import "./WebProfileHeader.vue?vue&type=style&index=0&id=6df7cb60&scoped=true&lang=css"

import exportComponent from "/var/www/matchmaker/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6df7cb60"]])

export default __exports__